module.exports = __webpack_public_path__ + "8ecfc9895141b2bdde7b52ec99cebaa3.png";